/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMenorah = createReactComponent("outline", "menorah", "IconMenorah", [["path", { "d": "M12 4v16", "key": "svg-0" }], ["path", { "d": "M8 4v2a4 4 0 1 0 8 0v-2", "key": "svg-1" }], ["path", { "d": "M4 4v2a8 8 0 1 0 16 0v-2", "key": "svg-2" }], ["path", { "d": "M10 20h4", "key": "svg-3" }]]);

export { IconMenorah as default };
//# sourceMappingURL=IconMenorah.mjs.map
